import type { ColumnMap } from "@/react/prop-types";
import { DateFilter } from "../data-table/custom-filters/date-filter";
import { NumericValueFilter } from "../data-table/custom-filters/numeric-value-filter";
import { BooleanFilter } from "../data-table/custom-filters/bool-filter";
import { TextFilter } from "../data-table/custom-filters/text-filter";
import { StatusFilter } from "../data-table/custom-filters/status-filter";
import { CheckboxFilterRenderer } from "../data-table/custom-filters/checkbox-filter";
import { ProjectRolesFilter } from "../data-table/custom-filters/project-roles-filter";
import { MultiSelectFilterRenderer } from "@procore/data-table";

export const filterRendererMap: ColumnMap = {
   start_date: DateFilter,
   end_date: DateFilter,
   percent_allocation: NumericValueFilter,
   overtime: BooleanFilter,
   employee_number: TextFilter,
   person_status: StatusFilter,
   project_status: StatusFilter,
   allocation_type: CheckboxFilterRenderer,
   project_roles: ProjectRolesFilter,
   cornerstone_stage: MultiSelectFilterRenderer,
};
